var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle2, _circle3, _path11, _path12, _path13, _path14, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccumulation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 144",
    fillRule: "evenodd",
    clipRule: "evenodd",
    "aria-hidden": "true"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.667,
    cy: 71.5,
    r: 49.5,
    fill: "#e5f5ff",
    stroke: "#18191b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.944 47.995c2.279 1.23 5.587 1.244 8.293.972.701-.07 1.36.304 1.744.881.384.574.448 1.272.075 1.838l-3.694 5.605c-.979 1.485-.135 3.441 1.35 4.141 2.472 1.165 5.129 3.148 7.491 5.42 2.362 2.271 4.402 4.804 5.657 7.048 1.893 3.388 3.704 7.423 4.643 11.258.944 3.856.979 7.397-.529 9.892-2.264 3.747-6.129 5.083-8.193 5.349a3.883 3.883 0 00-1.158.344c-1.276.604-5.661 2.257-15.442 2.257-9.791 0-14.37-1.656-15.72-2.264a3.879 3.879 0 00-1.208-.319c-1.593-.158-4.544-1.029-6.736-3.649-3.027-3.619-4.295-13.14 3.538-23.704 4.735-6.386 9.758-9.922 13.029-11.555 1.458-.728 2.199-2.685 1.219-4.121l-5.318-7.79c-.589-.863-.131-1.966.835-2.132 1.463-.25 3.334-.482 5.181-.465 1.857.017 3.633.287 4.943.994z",
    fill: "#fff",
    fillRule: "nonzero",
    stroke: "#383c42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.359 56.5c-2.218 0-4.69.501-6.349.939-.808.214-1.343.958-1.343 1.795 0 1.191 1.063 2.105 2.246 1.969 1.646-.188 3.718-.37 5.446-.37 1.839 0 4.159.205 5.941.406 1.119.127 2.139-.686 2.233-1.808.078-.929-.51-1.785-1.418-1.998-1.86-.437-4.548-.933-6.756-.933z",
    fill: "#31c48d",
    fillRule: "nonzero",
    stroke: "#18191b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.667 71.5v16m3-16c0 3.016 1 6.017 1 9.032V87.5",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.544 76.008c-.205-.886-1.165-1.625-2.042-1.97-.642-.252-1.333-.339-2.016-.45-.418-.068-.833-.128-1.252-.053-.554.099-1.142.069-1.671.262-1.092.4-2.16 1.031-2.765 1.98-.455.713-.446 1.575-.388 2.376.018.252.046.607.266.785.362.291.78.546 1.226.706a7.461 7.461 0 001.877.429c.732.06 1.458.278 2.167.456.768.193 1.524.393 2.245.707.224.097.425.296.631.425.234.146.44.291.628.485.256.262.697.513.824.85.256.676.409 1.371.392 2.086-.008.336-.266 1.15-.733 1.222-.3.047-.613.218-.894.328a12.37 12.37 0 01-2.063.595c-.668.13-1.414.21-2.097.25-.464.027-.966.048-1.424-.044-1.096-.221-1.711-1.162-2.417-1.885-.473-.484-.872-1.03-1.371-1.492m4 3.444v2m4-3v3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.165 108.691c-5.348 0-7.09-1.858-7.292-2.537V76.821c0-.543 1.458-2.13 7.292-2.13s6.887 1.587 6.685 2.13v29.333c0 .679-1.337 2.537-6.685 2.537zm18-2.5c-5.348 0-7.09-2.14-7.292-3.209V56.759c0-.856 1.458-2.568 7.292-2.568s6.887 1.712 6.685 2.568v46.223c0 1.069-1.337 3.209-6.685 3.209z",
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.873 111.191c-5.348 0-6.798-1.74-7-2.111v-16c0-.296 1.166-1.889 7-1.889 5.833 0 7.179 1.593 6.977 1.889v16c0 .371-1.63 2.111-6.977 2.111z",
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.873 111.191c-5.348 0-6.798-1.74-7-2.111v-16c0-.296 1.166-1.889 7-1.889 5.833 0 7.179 1.593 6.977 1.889v16c0 .371-1.63 2.111-6.977 2.111zm-62.206-9.219V88.389c0-.296 1.166-1.889 7-1.889s7.18 1.593 6.977 1.889v16c0 .37-1.629 2.111-6.977 2.111-1.268 0-2.316-.098-3.181-.252",
    fill: "#faca15",
    fillRule: "nonzero",
    stroke: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.873 76.691c-.167 1 1 3 7 3s7.166-2 7-3m-1.986 16.5c-.166 1 1 3 7 3s7.167-2 7-3M33.682 88.5c-.167 1 1 3 7 3s7.167-2 7-3m47.205-32.309c-.166 1 1 3 7 3s7.167-2 7-3",
    fill: "none",
    stroke: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.887 71.191c-.166 1 1 3 7 3m-7-1c-.166 1 1 3 7 3m-25 13c-.166 1 1 3 7 3m-7 3c-.166 1 1 3 7 3m-7-1c-.166 1 1 3 7 3m18.001-32c6 0 7.166-2 7-3m-7-4c6 0 7.166-2 7-3m-7 12c6 0 7.166-2 7-3m-7 17c6 0 7.166-2 7-3m-13 17c6 0 7.166-2 7-3M40.682 93.5c6 0 7.166-2 7-3m48.206 13.691c6 0 7.166-2 7-3M40.682 99.5c6 0 7.166-2 7-3m36.191-13.309c6 0 7.166-2 7-3m5.015 26c6 0 7.166-2 7-3M40.682 101.5c6 0 7.166-2 7-3m36.191-13.309c6 0 7.166-2 7-3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M77.429 69.082l.965-1.786c1.086-1.438 2.953-.642 6.94 1.672 2.061 1.197 3.723 3.077 4.669 5.784a.43.43 0 01-.139.288l-.782 1.623c-.842.117-3.29-.016-6.347-1.49-3.057-1.474-4.811-4.675-5.306-6.091z",
    fill: "#e3a008",
    fillRule: "nonzero"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M78.394 67.296l-.965 1.786c.495 1.416 2.249 4.617 5.306 6.091 3.057 1.474 5.505 1.607 6.347 1.49l.921-1.911m-11.609-7.456c1.086-1.438 2.953-.642 6.94 1.672 2.061 1.197 3.723 3.077 4.669 5.784m-11.609-7.456c.66 1.888 2.802 4.988 4.834 6.256 2.173 1.356 6.676 2.434 6.775 1.2",
    fill: "none",
    stroke: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.945 65.995c-.441-.428-.952-.79-1.431-1.174m2.576-.2c-.115-.507-.16-1.025-.315-1.523-.065-.21-.157-.408-.2-.624m11.995 7.615c.093-.538.029-1.087.029-1.632m.716 2.806c.476-.094.931-.262 1.402-.372",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.667,
    cy: 71.5,
    r: 49.5,
    fill: "none",
    stroke: "#18191b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.667,
    cy: 26.5,
    r: 22.5,
    fill: "#7ec4f6",
    stroke: "#18191b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.211 38.024l-.648-1.924c-.311-1.775 1.544-2.597 5.956-3.934 2.281-.692 4.789-.625 7.414.53a.424.424 0 01.116.298l.653 1.678c-.488.696-2.255 2.395-5.418 3.626-3.163 1.23-6.7.33-8.073-.274z",
    fill: "#faca15",
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.563 36.1l.648 1.924c1.373.604 4.91 1.504 8.073.274 3.163-1.231 4.93-2.93 5.418-3.626l-.769-1.976M93.563 36.1c-.311-1.775 1.544-2.597 5.956-3.934 2.281-.692 4.789-.625 7.414.53M93.563 36.1c1.831.806 5.558 1.353 7.872.732 2.473-.664 6.333-3.223 5.498-4.136",
    fill: "none",
    stroke: "#000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.412 27.074c.515-2.267 1.221-4.513 1.636-6.81.488-2.706 1.221-5.349 1.835-8.028.137-.598.225-1.132.225-1.736m-10.254 7.691c.037 2.038.119 4.071.119 6.115 0 .914-.239 1.921-.239 2.828",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.314 114a.5.5 0 00-1 0v2.147h-2.147a.5.5 0 000 1h2.147v2.147a.5.5 0 001 0v-2.147h2.147a.5.5 0 000-1h-2.147V114z",
    fillRule: "nonzero"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.667,
    cy: 44.5,
    r: 3.5,
    fill: "none",
    stroke: "#000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.667,
    cy: 28.5,
    r: 1.5,
    fill: "none",
    stroke: "#000"
  })));
}
export default SvgAccumulation;